export default __webpack_public_path__ + "static/media/Digital_DeliveryDark.a25cf5e0.svg";